var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39687 16.7937C7.32954 16.7937 5.5799 16.0778 4.14794 14.6458C2.71598 13.2138 2 11.4642 2 9.39687C2 7.32954 2.71598 5.5799 4.14794 4.14794C5.5799 2.71598 7.32954 2 9.39687 2C11.4642 2 13.2138 2.71598 14.6458 4.14794C16.0778 5.5799 16.7937 7.32954 16.7937 9.39687C16.7937 10.2314 16.661 11.0185 16.3954 11.7582C16.1299 12.4979 15.7696 13.1522 15.3144 13.7212L21.6871 20.0939C21.8957 20.3025 22 20.568 22 20.8905C22 21.2129 21.8957 21.4784 21.6871 21.6871C21.4784 21.8957 21.2129 22 20.8905 22C20.568 22 20.3025 21.8957 20.0939 21.6871L13.7212 15.3144C13.1522 15.7696 12.4979 16.1299 11.7582 16.3954C11.0185 16.661 10.2314 16.7937 9.39687 16.7937ZM9.39687 14.5178C10.8193 14.5178 12.0284 14.0199 13.0242 13.0242C14.0199 12.0284 14.5178 10.8193 14.5178 9.39687C14.5178 7.9744 14.0199 6.76529 13.0242 5.76956C12.0284 4.77383 10.8193 4.27596 9.39687 4.27596C7.9744 4.27596 6.76529 4.77383 5.76956 5.76956C4.77383 6.76529 4.27596 7.9744 4.27596 9.39687C4.27596 10.8193 4.77383 12.0284 5.76956 13.0242C6.76529 14.0199 7.9744 14.5178 9.39687 14.5178Z",
    fill: "#B7C2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDefault);
export default __webpack_public_path__ + "static/media/search_default.6d4202c701e3b84f685f4d84a4576ff2.svg";
export { ForwardRef as ReactComponent };